const NETWORK = () => ({
  state: {
    status: {
      requesting: false,
      error: "",
    },
  },
  reducers: {
    START_REQUESTING: (state) => {
      state.status.requesting = true;
      state.status.error = "";
    },
    FINISH_REQUESTING: (state) => {
      state.status.requesting = false;
    },
    FAILED_REQUESTING: (state, { payload }) => {
      state.status.error = payload.toString ? payload.toString() : payload;
    },
    RESET_STATUS: (state) => {
      state.status = { requesting: false, error: "" };
    },
  },
});

const ENTITY = () => ({
  state: {
    items: [],
    item: {},
  },
  reducers: {
    SET_ITEMS: (state, { payload }) => {
      state.items = payload;
    },
    SET_ITEM: (state, { payload }) => {
      state.item = payload;
    },
    RESET_ITEM: (state) => {
      state.item = {};
    },
  },
});

export const BASE_REDUCERS = {
  NETWORK,
  ENTITY,
};

/**
 * To override the logic in the base reducers use the same key(e.g "START_REQUESTING") in the service reducer
 * Carefully use reducers keys(e.g "START_FETCHING") from the base reducers when exporting actions,
 * since it's hard to debug misspelling.
 * @param {function[]} reducers - Desired base reducers
 */
export const getBaseReducers = (reducers) => {
  const result = { state: {}, reducers: {} };

  reducers.forEach((reducer) => {
    const { state, reducers: reducerReducers } = reducer();

    result.state = { ...result.state, ...state };
    result.reducers = { ...result.reducers, ...reducerReducers };
  });

  return result;
};
